/** @jsx jsx */
import { css, jsx } from '@emotion/react'
import React from 'react'
import { imagePath } from '../../utils/ImagePath'
import { Cautions } from '../../entites/FacilityCaution'
import { CardSection, Heading } from './CardSection'

export type CautionsViewProps = {
  cautions: Cautions
}

export const CautionsView = ({ cautions }: CautionsViewProps) => {
  const cautionsStyle = css`
    h2 {
      color: #ae000e;
    }

    ol {
      display: grid;
      row-gap: 20px;
      list-style: none;
      counter-reset: number 0;

      li {
        position: relative;
        padding-left: 22px;
      }

      li::before {
        position: absolute;
        top: 0;
        left: 0;
        counter-increment: number 1;
        content: counter(number) '.';
        padding-right: 0.5em;
        font-weight: bold;
        color: #ae000e;
      }
    }

    & a {
      margin-top: 10px;
      display: flex;
      column-gap: 6px;
      align-items: center;
      line-height: 160%;
      text-decoration-line: underline;
      &:visited,
      &:link {
        color: inherit;
      }

      &::before {
        content: '';
        display: inline-block;
        width: 18px;
        height: 18px;
        background: url(${imagePath('vector.svg')}) no-repeat;
        background-size: contain;
      }
      &.telephone::before {
        background: url(${imagePath('phone.svg')}) no-repeat;
        background-size: contain;
      }
      &[target='_blank']::after {
        content: '';
        display: inline-block;
        width: 14px;
        height: 14px;
        background: url(${imagePath('blank.svg')}) no-repeat;
        background-size: contain;
      }
    }
  `
  return (
    <CardSection css={cautionsStyle} id="cautions">
      <Heading>注意事項</Heading>
      <ol>
        {cautions.map((block) => (
          <li key={block.id}>
            {block.body}
            {block.items &&
              block.items.length > 0 &&
              block.items.map((item) => (
                <React.Fragment key={item.id}>
                  {item.type === 'link' && (
                    <a
                      href={item.href}
                      // 現状、常に別タブで開くで良いとのことで、targetBlank フィールドを無視する
                      target={'_blank'}
                      rel={'noopener noreferrer'}
                    >
                      {item.content}
                    </a>
                  )}
                  {item.type === 'telephone' && (
                    <a href={`tel:${item.content}`} className="telephone">
                      {item.content}
                    </a>
                  )}
                </React.Fragment>
              ))}
          </li>
        ))}
      </ol>
    </CardSection>
  )
}
